module.exports = __webpack_public_path__ + "Roboto-BlackItalic.4b7407c6740b8294d97a.eot";


//////////////////
// WEBPACK FOOTER
// /Desenvolvimento/PMP/painel/~/roboto-fontface/fonts/Roboto/Roboto-BlackItalic.eot
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-BlackItalic.eot
// module chunks = 34